import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "../Language/LanguageSelector";
import { LocaleLink } from "../Language/LocaleLink";
import { ThemeToggle } from "../ThemeToggle/ThemeToggle";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-md-3 col-sm-12">
            <h4 className="fw-bold h5 mb-3">onBookmarks</h4>
            <p>{t("footer.title")}</p>
          </div>
          <div className="col-md-2 col-6">
            <h5 className="fw-bold mb-3">{t("footer.product")}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <LocaleLink
                  to="/features"
                  className="text-decoration-none text-muted"
                >
                  {t("header.features")}
                </LocaleLink>
              </li>
              <li className="mb-2">
                <LocaleLink
                  to="/download/extensions"
                  className="text-decoration-none text-muted"
                >
                  {t("footer.extensions")}
                </LocaleLink>
              </li>
              <li className="mb-2">
                <Link
                  to="/security"
                  className="text-decoration-none text-muted"
                >
                  Security
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/features/mcp"
                  className="text-decoration-none text-muted"
                >
                  AI &amp; MCP
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2 col-6">
            <h5 className="fw-bold mb-3">{t("footer.resources")}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" className="text-decoration-none text-muted">
                  {t("footer.about")}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/docs" className="text-decoration-none text-muted">
                  {t("footer.documentation")}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/blog" className="text-decoration-none text-muted">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2 col-6">
            <h5 className="fw-bold mb-3">{t("footer.compare", "Compare")}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <LocaleLink
                  to="/pocket-alternative"
                  className="text-decoration-none text-muted"
                >
                  {t("footer.pocketAlternative")}
                </LocaleLink>
              </li>
              <li className="mb-2">
                <LocaleLink
                  to="/raindrop-alternative"
                  className="text-decoration-none text-muted"
                >
                  Raindrop alternative
                </LocaleLink>
              </li>
              <li className="mb-2">
                <Link
                  to="/instapaper-alternative"
                  className="text-decoration-none text-muted"
                >
                  Instapaper alternative
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/omnivore-alternative"
                  className="text-decoration-none text-muted"
                >
                  Omnivore alternative
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3 col-6">
            <h5 className="fw-bold mb-3">{t("footer.legal")}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/legal/terms-of-service"
                  className="text-decoration-none text-muted"
                >
                  {t("footer.terms")}
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/legal/privacy-policy"
                  className="text-decoration-none text-muted"
                >
                  {t("footer.privacy")}
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/legal/extension-privacy-policy"
                  className="text-decoration-none text-muted"
                >
                  Extension Privacy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="row mt-4 pt-4 border-top">
          <div className="col-md-6 d-flex align-items-center gap-3">
            <p className="mb-0 text-muted">{t("footer.copyright")}</p>
          </div>
          <div className="col-md-6 text-md-end">
            <div className="d-flex justify-content-md-end align-items-center gap-3 mt-3 mt-md-0">
              <ThemeToggle />
              <div className="d-flex align-items-center gap-2">
                <span className="text-secondary">{t("footer.language")}</span>
                <LanguageSelector />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
